import camelCase from 'lodash-es/camelCase'
import isEmpty from 'lodash-es/isEmpty'
import { useEffect } from 'react'
import { useGlobalContext } from '../Contexts/GlobalContext'
import { AreaType } from '../globalHeader/GlobalHeader'
import { newContentSeen } from '../globalHeader/functions/ams-functions'

export const useNewContent = (pathname: string) => {
    const { userData, area, setUserData } = useGlobalContext()

    useEffect(() => {
        let timeout
        let key = camelCase(pathname)
        if (isEmpty(key)) {
            // root path
            key = area === AreaType.PLAY_AREA ? 'play' : 'home'
        }

        if (userData?.newContent?.[key] === true) {
            timeout = setTimeout(async () => {
                setUserData({ ...userData, newContent: { ...userData.newContent, [key]: false } })
                const newContent = await newContentSeen(key)
                newContent && !newContent.error && setUserData({ ...userData, newContent })
            }, 50)
        }
        return () => {
            clearTimeout(timeout)
        }
    }, [pathname, userData?.id])
}
